import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import { Subscription } from "rxjs";
import { KostenExtraGezinshulpComponent } from './kosten-extra-gezinshulp/kosten-extra-gezinshulp.component';
import { BehandelkostenComponent } from './behandelkosten/behandelkosten.component';
import { MedicijnenComponent } from './medicijnen/medicijnen.component';
import { HulpmiddelenComponent } from './hulpmiddelen/hulpmiddelen.component';
import { ReiskostenEigenZorgComponent } from './reiskosten-eigen-zorg/reiskosten-eigen-zorg.component';
import { DietenComponent } from './dieten/dieten.component';
import { ReiskostenZorgGezinslidComponent } from './reiskosten-zorg-gezinslid/reiskosten-zorg-gezinslid.component';
import {
  ExtraUitgavenKledingEnBeddengoedComponent
} from './extra-uitgaven-kleding-en-beddengoed/extra-uitgaven-kleding-en-beddengoed.component';
import { CommonModule } from '@angular/common';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiAlertModule } from '@snelstart/ui-alert';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten',
  templateUrl: './pga-specifieke-zorgkosten.component.html',
  styleUrls: ['./pga-specifieke-zorgkosten.component.scss'],
    imports: [
        KostenExtraGezinshulpComponent,
        BehandelkostenComponent,
        MedicijnenComponent,
        HulpmiddelenComponent,
        ReiskostenEigenZorgComponent,
        DietenComponent,
        ReiskostenZorgGezinslidComponent,
        ExtraUitgavenKledingEnBeddengoedComponent,
        CommonModule,
        SharedUiButtonModule,
        SharedUiFormControlsModule,
        SharedUiAlertModule
    ]
})
export class PgaSpecifiekeZorgkostenComponent implements OnInit, OnDestroy {
  private drempelZorgkostenSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;

    @Input() aangifte = {} as Aangifte;
    @Input() public incomeTaxEntity = {} as IncomeTaxEntity;

    drempelZorgkosten: any;

    constructor(public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
    }

    public ngOnInit(): void {
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
        this.incomeTaxEntity = incomeTaxEntity;
        if (incomeTaxEntity.aangifte) {
          const aangifte = incomeTaxEntity.aangifte;
          this.aangifte = aangifte;
        }
      });
      this.drempelZorgkostenSubscription =this.dataService.drempelZorgkosten.subscribe((value) => {
            this.drempelZorgkosten = value;
        });
    }

  ngOnDestroy(): void {
    if (this.drempelZorgkostenSubscription) {
      this.drempelZorgkostenSubscription.unsubscribe(); // Unsubscribe from income tax entity
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

}
